var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('page-title',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t("contact"))))]),_c('h5',[_vm._v("Facebook")]),_c('h5',[_vm._v("Instagram")]),_c('h5',[_vm._v("E-mail")]),_c('h5',[_vm._v("...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }